/**
 * Represents the one search change the viewport search core applies for a settled map position.
 */
export default class ViewportSearchDecisionType {

  /**
   * It represents leaving the search as it is.
   */
  static get None() {
    return this.getInstance('none');
  }

  /**
   * It represents starting a focused search on the given bounds.
   */
  static get EnterFocused() {
    return this.getInstance('enterFocused');
  }

  /**
   * It represents moving an active focused search to the given bounds.
   */
  static get UpdateFocused() {
    return this.getInstance('updateFocused');
  }

  /**
   * It represents ending focused search and clearing its bounds.
   */
  static get ExitFocused() {
    return this.getInstance('exitFocused');
  }

  /**
   * It represents a search within map (rectangular-area) search of the given bounds.
   */
  static get SearchRectangle() {
    return this.getInstance('searchRectangle');
  }

  /**
   * It represents refreshing a State search for the given bounds.
   */
  static get RefreshState() {
    return this.getInstance('refreshState');
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new ViewportSearchDecisionType(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(ViewportSearchDecisionType, 'instances', { value: {} });
